import {
  Award,
  Zap,
  Heart,
  Target,
  Shield,
  Crown,
  Flame,
  Compass,
  Map,
  Globe,
  Star,
  Eye,
  Camera,
  Users,
  Sparkles,
} from 'lucide-react';

const BADGE_SLUG_ICONS: Record<string, typeof Award> = {
  'first-scan': Zap,
  'feedback-starter': Heart,
  regular: Target,
  dedicated: Shield,
  veteran: Crown,
  '3-day-streak': Flame,
  'week-warrior': Flame,
  'fortnight-force': Flame,
  'month-master': Flame,
  century: Flame,
  'building-explorer': Compass,
  'city-scout': Map,
  'globe-trotter': Globe,
  'logo-starter': Star,
  'brand-collector': Star,
  'logo-legend': Crown,
  'issue-spotter': Eye,
  'quality-eye': Eye,
  photographer: Camera,
  recruiter: Users,
  ambassador: Users,
  'company-connector': Globe,
  'early-adopter': Sparkles,
};

const CATEGORY_ICONS: Record<string, typeof Award> = {
  FUNDAMENTALS: Target,
  STREAKS: Flame,
  EXPLORATION: Map,
  QUALITY: Eye,
  SOCIAL: Users,
  SPECIAL: Sparkles,
};

export function getBadgeIcon(slug: string, category?: string): typeof Award {
  return BADGE_SLUG_ICONS[slug] || (category ? CATEGORY_ICONS[category] : null) || Award;
}

export { CATEGORY_ICONS };
